import { useTranslation } from 'next-i18next';
import { useState, useRef, useEffect, ElementType } from 'react';
import styled from 'styled-components';
import { scrollToComponent } from '../helpers/common';
import { useRouter } from 'next/router';

interface ShowMoreLessProps {
  text: any;
  ActionButton?: ElementType;
}
interface ContainerProps {
  maxHeight: number | null;
}

const ShowMoreLess = ({ text, ActionButton }: ShowMoreLessProps) => {
  const { t } = useTranslation('common');

  const textContainerRef = useRef<any>(null);
  const { asPath } = useRouter();

  const [isMoreLines, setIsMoreLines] = useState(false);
  const [isFullText, setIsFullText] = useState(true);

  const handleShowMoreLess = () => {
    if (isFullText) {
      scrollToComponent('head', 300);
    }
    setIsFullText(!isFullText);
  };
  const maxHeight = textContainerRef?.current?.clientHeight;

  useEffect(() => {
    if (textContainerRef?.current?.clientHeight > 200) {
      setIsMoreLines(true);
    }

    if (asPath.includes('/compound')) {
      return asPath.includes('/property')
        ? () => setIsFullText(false)
        : () => {};
    }
  }, [maxHeight, asPath]);

  const getActionButton = () => {
    if (ActionButton) {
      return (
        <ActionButton
          isFullText={isFullText}
          handleShowMoreLess={handleShowMoreLess}
        />
      );
    }

    return (
      <div className="btn-container">
        <button onClick={handleShowMoreLess} data-test="show-more-less">
          {isFullText ? t('See Less') : t('See More')}
        </button>
      </div>
    );
  };

  return (
    <Container
      maxHeight={maxHeight}
      className={isFullText ? 'full-content' : 'short-content'}
    >
      <div
        className="text-container"
        ref={textContainerRef}
        data-cy="description-container"
      >
        {text}
      </div>
      {isMoreLines && getActionButton()}
    </Container>
  );
};

const Container = styled.div<ContainerProps>`
  overflow: hidden;
  transition: all 0.6s ease-out;
  position: relative;
  height: auto;

  &.short-content {
    max-height: 200px;
  }

  &.full-content {
    height: ${props => props.maxHeight && props.maxHeight + 60}px;
  }

  .btn-container {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-top: 8px;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 70%,
      rgba(255, 255, 255, 0.4150910364145658) 100%
    );

    display: flex;

    button {
      font-size: ${props => props.theme.font.sizes.s};
      border: 1px solid ${props => props.theme.light.borderColors.primary};
      background-color: transparent;
      height: 40px;
      color: ${props => props.theme.light.colors.primaryBlue};
      font-family: materialMedium;
      cursor: pointer;
      padding: 6px 12px;
      border-radius: ${props => props.theme.borderRadius};
      align-self: flex-end;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease-out;
      :hover {
        @media (hover: hover) and (pointer: fine) {
          border: 1px solid
            ${props => props.theme.light.hoverColors.primaryBlue};
        }
      }
    }
  }
`;
export default ShowMoreLess;
